import { Form } from '@tribeplatform/react-components/Form'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useNetwork, useUpdateNetwork } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const PostTranslation = () => {
  const { $t } = useI18n()
  const { data: network } = useNetwork()
  const { mutateAsync: updateNetwork, isLoading } = useUpdateNetwork()

  return (
    <Card>
      <Card.Header
        title={$t({
          defaultMessage: 'Content translation',
          id: 'Admin.LanguageSettings.ContentTranslation',
        })}
      />
      <Card.Content>
        <Form
          defaultValues={{
            contentTranslation: network?.settings?.contentTranslation?.enabled,
          }}
          onSubmit={async data => {
            const { contentTranslation } = data
            await updateNetwork({
              input: {
                settings: {
                  contentTranslation: {
                    enabled: contentTranslation,
                  },
                },
              },
            })
            toast({
              title: $t({
                defaultMessage: 'Localization settings updated',
                id: 'Admin.LanguageSettings.LocalizationSettingsUpdated',
              }),
              status: 'success',
            })
          }}
        >
          <div className="web:col-span-12 web:md:col-span-8 flex flex-col space-y-5">
            <Form.Toggle
              name="contentTranslation"
              label={$t({
                defaultMessage: 'Allow post translation',
                id: 'Admin.LanguageSettings.AllowPostTranslation',
              })}
              helperText={$t({
                defaultMessage:
                  'Show "See translation" option under posts that are not in member\'s preferred language.',
                id: 'Admin.LanguageSettings.AllowPostTranslationHelperText',
              })}
            />
            <Form.Actions>
              <Button type="submit" loading={isLoading}>
                <T defaultMessage="Update" id="Generics.Update" />
              </Button>
            </Form.Actions>
          </div>
        </Form>
      </Card.Content>
    </Card>
  )
}
